<template>
    <app-navbar :logo-url="logo"
                :user="user.loggedInUser"
                :permission="permissionList"
                :selected-language="userLanguage"
                :language-data="languageList"
                :notificationData="notificationList"
                :showIdentifier="showIdentifier"
                all-notification-url="/history"
                @clicked="readNotification"/>
</template>

<script>
    import {UserMixin} from '../Auth/Mixins/UserMixin';
    import * as actions from '../../../Config/ApiUrl';
    import {axiosPost} from "../../../Helpers/AxiosHelper";
    import {mapActions} from "vuex";
    import AppFunction from "../../../../core/helpers/app/AppFunction";

    export default {
        name : 'DashboardNavbar',
        mixins: [UserMixin],
        props: {
            logo: {
                type: String,
                default: AppFunction.getAppUrl('images/icon.png')
            }
        },
        data(){
            return{
                languageData: [
                    {
                        img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Flag_of_Great_Britain_%281707%E2%80%931800%29.svg/1024px-Flag_of_Great_Britain_%281707%E2%80%931800%29.svg.png',
                        title: 'English',
                        url: 'gp.com'
                    },
                    {
                        img: 'https://cdn.countryflags.com/thumbs/spain/flag-400.png',
                        title: 'Čeština',
                        url: 'pathao.com'
                    },
                    {
                        img: 'https://upload.wikimedia.org/wikipedia/commons/b/bc/Flag_of_India.png',
                        title: 'Slovenčina',
                        url: 'ul.com'
                    },
                ],

            }
        },
        created() {
            this.$store.dispatch('getSettings');
            this.$store.dispatch('getNotifications');
            this.$store.dispatch('setSelectedLanguage');
            this.$store.dispatch('getUser');
            this.$store.dispatch('getPermissions');

            // this.$store.dispatch('getLanguages');
            // Error => Trying to access array offset on value of type null
        },
        computed: {
            languageList() {
                return this.$store.state.settings.languages
            },
            permissionList() {
                return this.$store.state.userAndRoles.permissionList
            },
            userLanguage() {
                return window.localStorage.getItem('app-language').toUpperCase()
            },
            showIdentifier() {
                const notifications = this.$store.getters.notificationList;
                return !(notifications && notifications.length && notifications.total_unread) ? false : true;
            }
        },

        methods: {
            ...mapActions([
                'getNotifications'
            ]),
            readNotification(notification) {
                axiosPost(`admin/user/notifications/mark-as-read/${notification.id}`).then(({data}) => {
                    if (data.data.url) {
                        window.location = data.data.url;
                    }
                    this.getNotifications();
                });
            }
        }
    }
</script>
